import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_ai-garment-try-on/artifacts/skm3z4j3_Photoroom_20251125_232246.jpeg";

export const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/10 py-16 md:py-24" data-testid="footer">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-6">
              <img src={LOGO_URL} alt="TailorGlam" className="w-10 h-10 object-contain" />
              <span className="font-heading text-2xl font-medium tracking-tight text-white">
                TailorGlam
              </span>
            </Link>
            <p className="text-gray-500 font-light max-w-sm leading-relaxed">
              Experience fashion like never before. Try on custom designs virtually 
              before you order. Powered by advanced AI technology.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-mono text-sm tracking-widest uppercase mb-6 text-[#FF1493]">
              Navigate
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/gallery" className="text-gray-500 hover:text-white transition-colors">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/style-guide" className="text-gray-500 hover:text-white transition-colors">
                  Style Guide
                </Link>
              </li>
              <li>
                <Link to="/subscription" className="text-gray-500 hover:text-white transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/studio" className="text-gray-500 hover:text-white transition-colors">
                  Studio
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-mono text-sm tracking-widest uppercase mb-6 text-[#FF1493]">
              Contact
            </h4>
            <ul className="space-y-3 text-gray-500">
              <li>
                <a href="mailto:tailorglamenterpriseinc@gmail.com" className="hover:text-white transition-colors">
                  tailorglamenterpriseinc@gmail.com
                </a>
              </li>
              <li>
                <a href="tel:+14388285347" className="hover:text-white transition-colors">
                  438-828-LEGS
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-16 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-600 text-sm">
            &copy; {new Date().getFullYear()} TailorGlam. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-600">
            <span className="hover:text-white cursor-pointer transition-colors">Privacy</span>
            <span className="hover:text-white cursor-pointer transition-colors">Terms</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
